module.exports = "<div> <group-title>不设置默认值时，赋值并选中第一个</group-title> <picker :data=years :value.sync=year1 @change=change></picker> <group-title>设置默认值时</group-title> <picker :data=years :value.sync=year2 @change=change></picker> <group-title>双向绑定</group-title> <input v-model=year3 /> <picker :data=years :value.sync=year3 @change=change></picker> <group-title>多列非联动</group-title> <picker :data=data4 :value.sync=data4Value @change=change></picker> <group-title>多列联动</group-title> <picker :data=data5 :columns=3 :value.sync=data5Value @change=change></picker> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/demos/Picker.vue
 ** module id = 194
 ** module chunks = 0
 **/